import { inspectionCatalogV1EsES } from "./catalog/v1/es-ES";

export const inspectionEsES = {
  title: "Inspección",
  loading: "Cargando…",
  actions: {
    new: "Nueva inspección",
    openForm: "Abrir ficha",
    delete: "Eliminar",
    cancel: "Cancelar",
    close: "Cerrar",
    back: "Volver",
    next: "Siguiente",
    save: "Guardar",
    finalize: "Finalizar",
    add: "Agregar",
    filter: "Filtrar",
    clearFilters: "Limpiar filtros",
    download: "Descargar",
    downloadReport: "Descargar",
  },
  kpi: {
    finalized: "Finalizadas",
  },
  conservationState: {
    title: "Estado de conservación",
    caption:
      "Estado de conservación (actual de la estructura — Clasificación ANM)",
    sum: "∑EC",
    empty: "Estado de conservación aún no completado.",
    orient:
      "Marque el peso correspondiente; si alguna columna tiene peso 10, proceda con inspección especial.",
    specialWarnBefore:
      "Peso 10 seleccionado en al menos una columna — proceda con ",
    specialWarnEmphasis: "inspección especial",
    specialWarnAfter: " según la norma ANM.",
  },
  chart: {
    title: "Seguimiento",
    period: "Período",
    monthAbbrev: {
      jan: "ene",
      feb: "feb",
      mar: "mar",
      apr: "abr",
      may: "may",
      jun: "jun",
      jul: "jul",
      aug: "ago",
      sep: "sep",
      oct: "oct",
      nov: "nov",
      dec: "dic",
    },
    periodMonths: {
      three: "Últimos 3 meses",
      six: "Últimos 6 meses",
      twelve: "Últimos 12 meses",
    },
    empty: "Sin datos en el período",
    series: {
      total: "Total",
      finalized: "Finalizadas",
      notFinalized: "No finalizadas",
      scheduled: "Programadas",
      manual: "No programadas",
    },
  },
  table: {
    filterButtonText: "Filtros",
    empty: "Ninguna inspección registrada para esta estructura.",
    emptyFiltered: "Ninguna inspección encontrada con los filtros aplicados.",
    fallback: "—",
    columns: {
      code: "Cód. inspección",
      responsible: "Responsable de la inspección",
      date: "Fecha",
      conservationState: "Estado de conservación",
      anomalies: "Cant. anomalías",
      status: "Estado",
      origin: "Origen",
      pdf: "Ficha de inspección",
    },
    pdfAvailableAfterFinalize: "Disponible después de finalizar",
    pdfUnavailable: "Ficha de inspección aún no disponible para descargar",
    pdfPreviewTitle: "Ficha de inspección",
    pdfVerificationCode: "Código de verificación:",
  },
  status: {
    open: "Abierta",
    inProgress: "en curso",
    finalized: "finalizada",
    notFinalized: "No finalizada",
  },
  origin: {
    scheduled: "Programada",
    manual: "No programada",
  },
  filters: {
    code: "Cód. inspección",
    responsible: "Responsable de la inspección",
    dateFrom: "Desde",
    dateTo: "Hasta",
    status: "Estado",
    origin: "Origen",
    hasAnomalies: "Con anomalías",
    all: "Todos",
    allFeminine: "Todas",
    yes: "Sí",
    no: "No",
    codePlaceholder: "Ej.: 42",
    responsiblePlaceholder: "Escriba el nombre…",
    dateRangeInvalid: "La fecha inicial no puede ser posterior a la fecha final",
  },
  form: {
    title: "Ficha de inspección",
    titleWithCode: "Ficha de la inspección #{{code}}",
    unsupportedVersion:
      "Versión de ficha no compatible con esta versión del sistema ({{version}}). Recargue la página; si persiste, contacte al soporte.",
    stepsHeading: "Etapas de la ficha",
    stepOf: "Etapa {{current}} de {{total}}",
    saveAndContinue: "Guardar y continuar",
    removeOccurrence: "Eliminar",
    selectPlaceholder: "Seleccione…",
    stepLocked: "Avance por las etapas anteriores para liberar",
    stepIncomplete:
      "Responda los ítems obligatorios de este paso para guardar y continuar. Los campos incompletos están marcados abajo.",
    fieldErrorAnswer: "Seleccione una opción.",
    fieldErrorObservations: "Complete las observaciones.",
    fieldErrorPhotos: "Envíe al menos una foto.",
    fieldErrorValue: "Complete este campo.",
    readOnly: "Solo lectura",
    readOnlyWithStatus: "Solo lectura ({{status}})",
    extrasHint:
      "Un participante extra se puede quitar mientras aún no haya firmado.",
    stepNotApplicable:
      "Paso marcado como no aplicable — ítems ocultos y fuera del conteo de anomalías.",
    stepAppliesQuestion: "¿Esta etapa se aplica a la estructura?",
    observationsPlaceholder: "Describa la condición observada…",
    observationsPlaceholderOptional: "Observaciones (opcional)…",
    anomalyReqNote:
      "Respuesta marcada como anomalía — Observaciones y foto obligatorias.",
    anomalyReqNoteGrade:
      "“Regular” y “Deficiente” cuentan como anomalía — Observaciones y foto obligatorias.",
    collapseExpand: "Expandir",
    collapseMinimize: "Minimizar",
    occurrenceEmpty: "“Sí” exige ≥ 1 registro. Agregue al menos uno.",
    occurrenceEmptyCrack: "“Sí” exige ≥ 1 registro. Agregue trinca.",
    occurrenceEmptySettlement: "“Sí” exige ≥ 1 registro. Agregue recalque.",
    occurrenceEmptySeepage: "“Sí” exige ≥ 1 registro. Agregue surgencia.",
    occurrenceEmptyErosion: "“Sí” exige ≥ 1 registro. Agregue erosión.",
    occurrenceEmptyChannel:
      "“Sí” exige ≥ 1 línea. Agregue al menos una línea de canal.",
    occurrenceEmptyGeomembrane:
      "Regular/Deficiente exige ≥ 1 ocurrencia de geomembrana.",
    collapseYesPending: "Sí — pendiente",
    collapseRecordCount: "{{count}} registro(s)",
    collapseLineCount: "{{count}} línea(s)",
    collapseCleanliness: "Limpieza",
    collapseStructure: "Estructura",
    pendingSummary: "Pendiente",
    optionalSummary: "Opcional",
    occurrencePendingTag: "Registro pendiente",
    entryLineTag: "Línea {{n}}",
    drainageChannelDoubleAnomalyHint:
      "Limpieza Regular/Deficiente y estructura Regular/Deficiente cuentan como anomalías independientes (+2 en esta línea).",
    anomalyTag: "anomalía",
    naCheckbox: "N/A (no aplica)",
    entryAnomNote: "Cada registro cuenta como 1 anomalía.",
    entryAnomNoteGeomembrane: "Cada ocurrencia (G1, G2…) cuenta como 1 anomalía.",
    hintOptional:
      "Opcional — no cuenta anomalía y no bloquea la finalización.",
    hintInformative:
      "Solo informativo — no cuenta anomalía y no exige foto.",
    hintInformativeNoNa:
      "Solo informativo — no cuenta anomalía. Sin opción N/A.",
    extraSourceLegend: "Incluir como",
    extraSourceName: "Persona externa",
    extraSourceGs3User: "Usuario de GS3",
    extraSourceHelpAria: "Qué es usuario de GS3 y persona externa",
    extraSourceHelpGs3:
      "Usuario de GS3: ya tiene cuenta en el sistema. El nombre viene del registro.",
    extraSourceHelpExternal:
      "Persona externa: no tiene cuenta en GS3. Indique el nombre de la persona.",
    extraDuplicate: "Este participante ya está en la inspección.",
    gs3User: "Usuario de GS3",
    gs3UserPlaceholder: "Buscar usuario…",
    gs3UserNotFound: "Ningún usuario encontrado",
    participantNamePlaceholder: "Nombre de la persona",
    generalData: {
      code: "Código de la inspección",
      responsible: "Responsable de la inspección",
      date: "Fecha de la inspección",
      dateScheduledSuffix: "(programada — no se puede cambiar)",
      extraParticipants: "Participantes extras",
      addExtraParticipant: "Agregar",
      extraParticipantName: "Nombre",
    },
    generalComments: {
      label: "Comentarios generales",
      placeholder:
        "Detallar todos los puntos observados en la inspección, incluir mantenimientos, obras o intervenciones en la estructura…",
    },
  },
  photos: {
    remove: "Eliminar",
    expand: "Ampliar {{name}}",
    preview: "Foto {{name}}",
    closePreview: "Cerrar foto",
    previous: "Foto anterior",
    next: "Foto siguiente",
    counter: "{{current}} de {{total}}",
    save: "Guardar",
    deleteTitle: "Quitar foto",
    deleteCaption: "Foto a quitar:",
    deleteDescription:
      "La foto deja de aparecer en la ficha. Puede adjuntarla de nuevo si lo necesita.",
    deleteConfirm: "Quitar",
    deleteCancel: "Cancelar",
    acceptHint: "Formatos aceptados: JPEG, PNG o WebP (rechazo: COD. 6.10.15)",
    tooLarge: "Archivo mayor que 10 MB",
  },
  participants: {
    title: "Participantes",
    signLead:
      "Participantes registrados en Datos generales. La firma se hace en esta etapa. Finalizar solo aquí.",
    name: "Nombre",
    add: "Agregar",
    addTitle: "Agregar participante",
    remove: "Eliminar",
    signed: "Firmado",
    pending: "Sin firma",
    pendingSignature: "Pendiente de firma",
    sign: "Firmar",
    resign: "Volver a firmar",
    roleResponsible: "Responsable",
    roleExtra: "Extra",
    kindGs3: "GS3",
    kindExternal: "Externa",
    finalizeHint:
      "Finalizar se habilita cuando todos los participantes hayan firmado.",
  },
  signature: {
    titleWithName: "Firmar — {{name}}",
    fonts: {
      classic: "Clásica",
      elegant: "Elegante",
      casual: "Casual",
      bold: "Marcada",
      modern: "Moderna",
      rounded: "Redondeada",
    },
    name: "Nombre en la firma",
    font: "Elija la fuente de firma",
    preview: "Vista previa en vivo",
    confirm: "Confirmar firma",
    signedAt: "Firmado el",
  },
  finalize: {
    title: "Finalizar inspección",
    subtitle:
      "Revise el resumen abajo. Al confirmar, la ficha queda solo lectura y se genera el PDF.",
    warningBefore: "Esta acción ",
    warningIrreversible: "no se puede deshacer",
    warningAfter:
      ". Tras finalizar, ningún dato de la ficha podrá alterarse.",
    confirm: "Confirmar y finalizar",
    confirming: "Finalizando…",
    cancel: "Cancelar",
    code: "Código",
    inspectionDate: "Fecha de la inspección",
    signatures: "Firmas",
    signaturesOf: "{{signed}} de {{total}}",
    anomalyCount: "Cantidad de anomalías",
    ecSum: "Sumatorio EC",
  },
  delete: {
    title: "Eliminar ítem permanentemente",
    caption: "Ítem a eliminar:",
    description:
      "Esta acción es irreversible. Los datos no podrán recuperarse después de la eliminación.",
    confirm: "Eliminar",
    cancel: "Cancelar",
    item: "Inspección #{{code}} — {{date}}",
  },
  catalog: {
    v1: inspectionCatalogV1EsES,
  },
};
